import { Table } from '@dixa/lib-shared-habla';
import { flexRender, type Table as TanstackTable } from '@tanstack/react-table';
import type { SearchConversationEnriched } from 'lib-search-types';

import type { ConversationsTableFeatures } from '../../../conversationsTable.columns';
import { TextPlaceholder } from '../../placeholders/textPlaceholder/textPlaceholder';

export type ConversationsTableHeadRowProps = {
  /** The table whose column headers are rendered. */
  table: TanstackTable<ConversationsTableFeatures, SearchConversationEnriched>;
  /** Whether the table has been initialized. */
  isInitialized?: boolean;
};

export const ConversationsTableHeadRow = ({
  table,
  isInitialized,
}: ConversationsTableHeadRowProps): JSX.Element => {
  return (
    <Table.Tr>
      {table.getLeafHeaders().map((header) => {
        const meta = header.column.columnDef.meta;

        if (!isInitialized) {
          return (
            <Table.Th key={header.id} width={meta?.width} columnId={null}>
              {meta?.placeholder?.header && (
                <TextPlaceholder width={meta.placeholder.header} />
              )}
            </Table.Th>
          );
        }

        return (
          <Table.Th
            key={header.id}
            width={meta?.width}
            tooltip={meta?.tooltip}
            columnId={meta?.sortBy ?? null}
          >
            {flexRender(header.column.columnDef.header, header.getContext())}
          </Table.Th>
        );
      })}
    </Table.Tr>
  );
};
